import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FooterComponent } from '../../components/footer/footer.component';
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { ShopSearchComponent } from '../../components/shop-search/shop-search.component';
import { FirebaseService } from '../../services/firebase.service';
import { errorKey } from '../../utils/format';
import { ShopSummary } from '../../../../../src/types';

/**
 * The home page, for shop owners: type your shop's address, and a minute later
 * search your own catalogue the way your customers would. "Put it on my shop"
 * carries the address to /business, which adds it after a login.
 *
 * `/?try=shop.bg` runs the demo straight away, so a link to a shop's own demo
 * can be sent to its owner.
 */
@Component({
   selector: 'app-index',
   standalone: true,
   imports: [NavbarComponent, FooterComponent, TranslateModule, RouterModule, FormsModule, ShopSearchComponent],
   templateUrl: './index-page.component.html',
})
export class IndexPageComponent implements OnInit {
   address = '';
   reading = false;
   shop: ShopSummary | null = null;
   errorKey = '';

   constructor(private firebaseService: FirebaseService, private route: ActivatedRoute, private router: Router) {}

   ngOnInit() {
      const address = this.route.snapshot.queryParamMap.get('try');
      if (address) {
         this.address = address;
         this.tryShop();
      }
   }

   tryShop() {
      const url = this.address.trim();
      if (!url || this.reading) return;
      this.reading = true;
      this.errorKey = '';
      this.shop = null;
      this.firebaseService.getFunction('tryShop')({ url }).then((result) => {
         this.shop = result.data as ShopSummary;
      }).catch((error) => {
         this.errorKey = errorKey(error);
      }).finally(() => {
         this.reading = false;
      });
   }

   another() {
      this.shop = null;
      this.address = '';
   }

   install() {
      this.router.navigate(['/business'], { queryParams: { add: this.shop?.url ?? this.address.trim() } });
   }
}
